!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.TinyGallery = e() : t.TinyGallery = e();
}(window, function () {
  return function (t) {
    var e = {};

    function i(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, i), o.l = !0, o.exports;
    }

    return i.m = t, i.c = e, i.d = function (t, e, n) {
      i.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, i.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, i.t = function (t, e) {
      if (1 & e && (t = i(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (i.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        i.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, i.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return i.d(e, "a", e), e;
    }, i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, i.p = "", i(i.s = 5);
  }([function (t, e, i) {
    var n = i(1);
    "string" == typeof n && (n = [[t.i, n, ""]]);
    var o = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    i(2)(n, o);
    n.locals && (t.exports = n.locals);
  }, function (t, e, i) {}, function (t, e, i) {
    var n,
        o,
        s = {},
        r = (n = function n() {
      return window && document && document.all && !window.atob;
    }, function () {
      return void 0 === o && (o = n.apply(this, arguments)), o;
    }),
        l = function (t) {
      var e = {};
      return function (t, i) {
        if ("function" == typeof t) return t();

        if (void 0 === e[t]) {
          var n = function (t, e) {
            return e ? e.querySelector(t) : document.querySelector(t);
          }.call(this, t, i);

          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (t) {
            n = null;
          }
          e[t] = n;
        }

        return e[t];
      };
    }(),
        a = null,
        c = 0,
        u = [],
        h = i(3);

    function d(t, e) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i],
            o = s[n.id];

        if (o) {
          o.refs++;

          for (var r = 0; r < o.parts.length; r++) {
            o.parts[r](n.parts[r]);
          }

          for (; r < n.parts.length; r++) {
            o.parts.push(g(n.parts[r], e));
          }
        } else {
          var l = [];

          for (r = 0; r < n.parts.length; r++) {
            l.push(g(n.parts[r], e));
          }

          s[n.id] = {
            id: n.id,
            refs: 1,
            parts: l
          };
        }
      }
    }

    function p(t, e) {
      for (var i = [], n = {}, o = 0; o < t.length; o++) {
        var s = t[o],
            r = e.base ? s[0] + e.base : s[0],
            l = {
          css: s[1],
          media: s[2],
          sourceMap: s[3]
        };
        n[r] ? n[r].parts.push(l) : i.push(n[r] = {
          id: r,
          parts: [l]
        });
      }

      return i;
    }

    function f(t, e) {
      var i = l(t.insertInto);
      if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var n = u[u.length - 1];
      if ("top" === t.insertAt) n ? n.nextSibling ? i.insertBefore(e, n.nextSibling) : i.appendChild(e) : i.insertBefore(e, i.firstChild), u.push(e);else if ("bottom" === t.insertAt) i.appendChild(e);else {
        if ("object" != typeof t.insertAt || !t.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = l(t.insertAt.before, i);
        i.insertBefore(e, o);
      }
    }

    function v(t) {
      if (null === t.parentNode) return !1;
      t.parentNode.removeChild(t);
      var e = u.indexOf(t);
      e >= 0 && u.splice(e, 1);
    }

    function m(t) {
      var e = document.createElement("style");

      if (void 0 === t.attrs.type && (t.attrs.type = "text/css"), void 0 === t.attrs.nonce) {
        var n = function () {
          0;
          return i.nc;
        }();

        n && (t.attrs.nonce = n);
      }

      return y(e, t.attrs), f(t, e), e;
    }

    function y(t, e) {
      Object.keys(e).forEach(function (i) {
        t.setAttribute(i, e[i]);
      });
    }

    function g(t, e) {
      var i, n, o, s;

      if (e.transform && t.css) {
        if (!(s = "function" == typeof e.transform ? e.transform(t.css) : e.transform.default(t.css))) return function () {};
        t.css = s;
      }

      if (e.singleton) {
        var r = c++;
        i = a || (a = m(e)), n = T.bind(null, i, r, !1), o = T.bind(null, i, r, !0);
      } else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (i = function (t) {
        var e = document.createElement("link");
        return void 0 === t.attrs.type && (t.attrs.type = "text/css"), t.attrs.rel = "stylesheet", y(e, t.attrs), f(t, e), e;
      }(e), n = function (t, e, i) {
        var n = i.css,
            o = i.sourceMap,
            s = void 0 === e.convertToAbsoluteUrls && o;
        (e.convertToAbsoluteUrls || s) && (n = h(n));
        o && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
        var r = new Blob([n], {
          type: "text/css"
        }),
            l = t.href;
        t.href = URL.createObjectURL(r), l && URL.revokeObjectURL(l);
      }.bind(null, i, e), o = function o() {
        v(i), i.href && URL.revokeObjectURL(i.href);
      }) : (i = m(e), n = function (t, e) {
        var i = e.css,
            n = e.media;
        n && t.setAttribute("media", n);
        if (t.styleSheet) t.styleSheet.cssText = i;else {
          for (; t.firstChild;) {
            t.removeChild(t.firstChild);
          }

          t.appendChild(document.createTextNode(i));
        }
      }.bind(null, i), o = function o() {
        v(i);
      });

      return n(t), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
          n(t = e);
        } else o();
      };
    }

    t.exports = function (t, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = r()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var i = p(t, e);
      return d(i, e), function (t) {
        for (var n = [], o = 0; o < i.length; o++) {
          var r = i[o];
          (l = s[r.id]).refs--, n.push(l);
        }

        t && d(p(t, e), e);

        for (o = 0; o < n.length; o++) {
          var l;

          if (0 === (l = n[o]).refs) {
            for (var a = 0; a < l.parts.length; a++) {
              l.parts[a]();
            }

            delete s[l.id];
          }
        }
      };
    };

    var b,
        x = (b = [], function (t, e) {
      return b[t] = e, b.filter(Boolean).join("\n");
    });

    function T(t, e, i, n) {
      var o = i ? "" : n.css;
      if (t.styleSheet) t.styleSheet.cssText = x(e, o);else {
        var s = document.createTextNode(o),
            r = t.childNodes;
        r[e] && t.removeChild(r[e]), r.length ? t.insertBefore(s, r[e]) : t.appendChild(s);
      }
    }
  }, function (t, e) {
    t.exports = function (t) {
      var e = "undefined" != typeof window && window.location;
      if (!e) throw new Error("fixUrls requires window.location");
      if (!t || "string" != typeof t) return t;
      var i = e.protocol + "//" + e.host,
          n = i + e.pathname.replace(/\/[^\/]*$/, "/");
      return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, e) {
        var o,
            s = e.trim().replace(/^"(.*)"$/, function (t, e) {
          return e;
        }).replace(/^'(.*)'$/, function (t, e) {
          return e;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(s) ? t : (o = 0 === s.indexOf("//") ? s : 0 === s.indexOf("/") ? i + s : n + s.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }, function (t, e, i) {
    var n;
    /*! Hammer.JS - v2.0.7 - 2016-04-22
     * http://hammerjs.github.io/
     *
     * Copyright (c) 2016 Jorik Tangelder;
     * Licensed under the MIT license */

    /*! Hammer.JS - v2.0.7 - 2016-04-22
     * http://hammerjs.github.io/
     *
     * Copyright (c) 2016 Jorik Tangelder;
     * Licensed under the MIT license */

    !function (o, s, r, l) {
      "use strict";

      var a,
          c = ["", "webkit", "Moz", "MS", "ms", "o"],
          u = s.createElement("div"),
          h = "function",
          d = Math.round,
          p = Math.abs,
          f = Date.now;

      function v(t, e, i) {
        return setTimeout(E(t, i), e);
      }

      function m(t, e, i) {
        return !!Array.isArray(t) && (y(t, i[e], i), !0);
      }

      function y(t, e, i) {
        var n;
        if (t) if (t.forEach) t.forEach(e, i);else if (t.length !== l) for (n = 0; n < t.length;) {
          e.call(i, t[n], n, t), n++;
        } else for (n in t) {
          t.hasOwnProperty(n) && e.call(i, t[n], n, t);
        }
      }

      function g(t, e, i) {
        var n = "DEPRECATED METHOD: " + e + "\n" + i + " AT \n";
        return function () {
          var e = new Error("get-stack-trace"),
              i = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace",
              s = o.console && (o.console.warn || o.console.log);
          return s && s.call(o.console, n, i), t.apply(this, arguments);
        };
      }

      a = "function" != typeof Object.assign ? function (t) {
        if (t === l || null === t) throw new TypeError("Cannot convert undefined or null to object");

        for (var e = Object(t), i = 1; i < arguments.length; i++) {
          var n = arguments[i];
          if (n !== l && null !== n) for (var o in n) {
            n.hasOwnProperty(o) && (e[o] = n[o]);
          }
        }

        return e;
      } : Object.assign;
      var b = g(function (t, e, i) {
        for (var n = Object.keys(e), o = 0; o < n.length;) {
          (!i || i && t[n[o]] === l) && (t[n[o]] = e[n[o]]), o++;
        }

        return t;
      }, "extend", "Use `assign`."),
          x = g(function (t, e) {
        return b(t, e, !0);
      }, "merge", "Use `assign`.");

      function T(t, e, i) {
        var n,
            o = e.prototype;
        (n = t.prototype = Object.create(o)).constructor = t, n._super = o, i && a(n, i);
      }

      function E(t, e) {
        return function () {
          return t.apply(e, arguments);
        };
      }

      function w(t, e) {
        return typeof t == h ? t.apply(e && e[0] || l, e) : t;
      }

      function I(t, e) {
        return t === l ? e : t;
      }

      function C(t, e, i) {
        y(L(e), function (e) {
          t.addEventListener(e, i, !1);
        });
      }

      function k(t, e, i) {
        y(L(e), function (e) {
          t.removeEventListener(e, i, !1);
        });
      }

      function _(t, e) {
        for (; t;) {
          if (t == e) return !0;
          t = t.parentNode;
        }

        return !1;
      }

      function S(t, e) {
        return t.indexOf(e) > -1;
      }

      function L(t) {
        return t.trim().split(/\s+/g);
      }

      function A(t, e, i) {
        if (t.indexOf && !i) return t.indexOf(e);

        for (var n = 0; n < t.length;) {
          if (i && t[n][i] == e || !i && t[n] === e) return n;
          n++;
        }

        return -1;
      }

      function M(t) {
        return Array.prototype.slice.call(t, 0);
      }

      function P(t, e, i) {
        for (var n = [], o = [], s = 0; s < t.length;) {
          var r = e ? t[s][e] : t[s];
          A(o, r) < 0 && n.push(t[s]), o[s] = r, s++;
        }

        return i && (n = e ? n.sort(function (t, i) {
          return t[e] > i[e];
        }) : n.sort()), n;
      }

      function F(t, e) {
        for (var i, n, o = e[0].toUpperCase() + e.slice(1), s = 0; s < c.length;) {
          if ((n = (i = c[s]) ? i + o : e) in t) return n;
          s++;
        }

        return l;
      }

      var z = 1;

      function B(t) {
        var e = t.ownerDocument || t;
        return e.defaultView || e.parentWindow || o;
      }

      var N = "ontouchstart" in o,
          R = F(o, "PointerEvent") !== l,
          O = N && /mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent),
          q = 25,
          D = 1,
          j = 2,
          U = 4,
          Y = 8,
          X = 1,
          H = 2,
          W = 4,
          G = 8,
          J = 16,
          V = H | W,
          $ = G | J,
          Z = V | $,
          K = ["x", "y"],
          Q = ["clientX", "clientY"];

      function tt(t, e) {
        var i = this;
        this.manager = t, this.callback = e, this.element = t.element, this.target = t.options.inputTarget, this.domHandler = function (e) {
          w(t.options.enable, [t]) && i.handler(e);
        }, this.init();
      }

      function et(t, e, i) {
        var n = i.pointers.length,
            o = i.changedPointers.length,
            s = e & D && n - o == 0,
            r = e & (U | Y) && n - o == 0;
        i.isFirst = !!s, i.isFinal = !!r, s && (t.session = {}), i.eventType = e, function (t, e) {
          var i = t.session,
              n = e.pointers,
              o = n.length;
          i.firstInput || (i.firstInput = it(e));
          o > 1 && !i.firstMultiple ? i.firstMultiple = it(e) : 1 === o && (i.firstMultiple = !1);
          var s = i.firstInput,
              r = i.firstMultiple,
              a = r ? r.center : s.center,
              c = e.center = nt(n);
          e.timeStamp = f(), e.deltaTime = e.timeStamp - s.timeStamp, e.angle = lt(a, c), e.distance = rt(a, c), function (t, e) {
            var i = e.center,
                n = t.offsetDelta || {},
                o = t.prevDelta || {},
                s = t.prevInput || {};
            e.eventType !== D && s.eventType !== U || (o = t.prevDelta = {
              x: s.deltaX || 0,
              y: s.deltaY || 0
            }, n = t.offsetDelta = {
              x: i.x,
              y: i.y
            });
            e.deltaX = o.x + (i.x - n.x), e.deltaY = o.y + (i.y - n.y);
          }(i, e), e.offsetDirection = st(e.deltaX, e.deltaY);
          var u = ot(e.deltaTime, e.deltaX, e.deltaY);
          e.overallVelocityX = u.x, e.overallVelocityY = u.y, e.overallVelocity = p(u.x) > p(u.y) ? u.x : u.y, e.scale = r ? (h = r.pointers, d = n, rt(d[0], d[1], Q) / rt(h[0], h[1], Q)) : 1, e.rotation = r ? function (t, e) {
            return lt(e[1], e[0], Q) + lt(t[1], t[0], Q);
          }(r.pointers, n) : 0, e.maxPointers = i.prevInput ? e.pointers.length > i.prevInput.maxPointers ? e.pointers.length : i.prevInput.maxPointers : e.pointers.length, function (t, e) {
            var i,
                n,
                o,
                s,
                r = t.lastInterval || e,
                a = e.timeStamp - r.timeStamp;

            if (e.eventType != Y && (a > q || r.velocity === l)) {
              var c = e.deltaX - r.deltaX,
                  u = e.deltaY - r.deltaY,
                  h = ot(a, c, u);
              n = h.x, o = h.y, i = p(h.x) > p(h.y) ? h.x : h.y, s = st(c, u), t.lastInterval = e;
            } else i = r.velocity, n = r.velocityX, o = r.velocityY, s = r.direction;

            e.velocity = i, e.velocityX = n, e.velocityY = o, e.direction = s;
          }(i, e);
          var h, d;
          var v = t.element;
          _(e.srcEvent.target, v) && (v = e.srcEvent.target);
          e.target = v;
        }(t, i), t.emit("hammer.input", i), t.recognize(i), t.session.prevInput = i;
      }

      function it(t) {
        for (var e = [], i = 0; i < t.pointers.length;) {
          e[i] = {
            clientX: d(t.pointers[i].clientX),
            clientY: d(t.pointers[i].clientY)
          }, i++;
        }

        return {
          timeStamp: f(),
          pointers: e,
          center: nt(e),
          deltaX: t.deltaX,
          deltaY: t.deltaY
        };
      }

      function nt(t) {
        var e = t.length;
        if (1 === e) return {
          x: d(t[0].clientX),
          y: d(t[0].clientY)
        };

        for (var i = 0, n = 0, o = 0; o < e;) {
          i += t[o].clientX, n += t[o].clientY, o++;
        }

        return {
          x: d(i / e),
          y: d(n / e)
        };
      }

      function ot(t, e, i) {
        return {
          x: e / t || 0,
          y: i / t || 0
        };
      }

      function st(t, e) {
        return t === e ? X : p(t) >= p(e) ? t < 0 ? H : W : e < 0 ? G : J;
      }

      function rt(t, e, i) {
        i || (i = K);
        var n = e[i[0]] - t[i[0]],
            o = e[i[1]] - t[i[1]];
        return Math.sqrt(n * n + o * o);
      }

      function lt(t, e, i) {
        i || (i = K);
        var n = e[i[0]] - t[i[0]],
            o = e[i[1]] - t[i[1]];
        return 180 * Math.atan2(o, n) / Math.PI;
      }

      tt.prototype = {
        handler: function handler() {},
        init: function init() {
          this.evEl && C(this.element, this.evEl, this.domHandler), this.evTarget && C(this.target, this.evTarget, this.domHandler), this.evWin && C(B(this.element), this.evWin, this.domHandler);
        },
        destroy: function destroy() {
          this.evEl && k(this.element, this.evEl, this.domHandler), this.evTarget && k(this.target, this.evTarget, this.domHandler), this.evWin && k(B(this.element), this.evWin, this.domHandler);
        }
      };
      var at = {
        mousedown: D,
        mousemove: j,
        mouseup: U
      },
          ct = "mousedown",
          ut = "mousemove mouseup";

      function ht() {
        this.evEl = ct, this.evWin = ut, this.pressed = !1, tt.apply(this, arguments);
      }

      T(ht, tt, {
        handler: function handler(t) {
          var e = at[t.type];
          e & D && 0 === t.button && (this.pressed = !0), e & j && 1 !== t.which && (e = U), this.pressed && (e & U && (this.pressed = !1), this.callback(this.manager, e, {
            pointers: [t],
            changedPointers: [t],
            pointerType: "mouse",
            srcEvent: t
          }));
        }
      });
      var dt = {
        pointerdown: D,
        pointermove: j,
        pointerup: U,
        pointercancel: Y,
        pointerout: Y
      },
          pt = {
        2: "touch",
        3: "pen",
        4: "mouse",
        5: "kinect"
      },
          ft = "pointerdown",
          vt = "pointermove pointerup pointercancel";

      function mt() {
        this.evEl = ft, this.evWin = vt, tt.apply(this, arguments), this.store = this.manager.session.pointerEvents = [];
      }

      o.MSPointerEvent && !o.PointerEvent && (ft = "MSPointerDown", vt = "MSPointerMove MSPointerUp MSPointerCancel"), T(mt, tt, {
        handler: function handler(t) {
          var e = this.store,
              i = !1,
              n = t.type.toLowerCase().replace("ms", ""),
              o = dt[n],
              s = pt[t.pointerType] || t.pointerType,
              r = "touch" == s,
              l = A(e, t.pointerId, "pointerId");
          o & D && (0 === t.button || r) ? l < 0 && (e.push(t), l = e.length - 1) : o & (U | Y) && (i = !0), l < 0 || (e[l] = t, this.callback(this.manager, o, {
            pointers: e,
            changedPointers: [t],
            pointerType: s,
            srcEvent: t
          }), i && e.splice(l, 1));
        }
      });
      var yt = {
        touchstart: D,
        touchmove: j,
        touchend: U,
        touchcancel: Y
      },
          gt = "touchstart",
          bt = "touchstart touchmove touchend touchcancel";

      function xt() {
        this.evTarget = gt, this.evWin = bt, this.started = !1, tt.apply(this, arguments);
      }

      T(xt, tt, {
        handler: function handler(t) {
          var e = yt[t.type];

          if (e === D && (this.started = !0), this.started) {
            var i = function (t, e) {
              var i = M(t.touches),
                  n = M(t.changedTouches);
              e & (U | Y) && (i = P(i.concat(n), "identifier", !0));
              return [i, n];
            }.call(this, t, e);

            e & (U | Y) && i[0].length - i[1].length == 0 && (this.started = !1), this.callback(this.manager, e, {
              pointers: i[0],
              changedPointers: i[1],
              pointerType: "touch",
              srcEvent: t
            });
          }
        }
      });
      var Tt = {
        touchstart: D,
        touchmove: j,
        touchend: U,
        touchcancel: Y
      },
          Et = "touchstart touchmove touchend touchcancel";

      function wt() {
        this.evTarget = Et, this.targetIds = {}, tt.apply(this, arguments);
      }

      T(wt, tt, {
        handler: function handler(t) {
          var e = Tt[t.type],
              i = function (t, e) {
            var i = M(t.touches),
                n = this.targetIds;
            if (e & (D | j) && 1 === i.length) return n[i[0].identifier] = !0, [i, i];
            var o,
                s,
                r = M(t.changedTouches),
                l = [],
                a = this.target;
            if (s = i.filter(function (t) {
              return _(t.target, a);
            }), e === D) for (o = 0; o < s.length;) {
              n[s[o].identifier] = !0, o++;
            }
            o = 0;

            for (; o < r.length;) {
              n[r[o].identifier] && l.push(r[o]), e & (U | Y) && delete n[r[o].identifier], o++;
            }

            if (!l.length) return;
            return [P(s.concat(l), "identifier", !0), l];
          }.call(this, t, e);

          i && this.callback(this.manager, e, {
            pointers: i[0],
            changedPointers: i[1],
            pointerType: "touch",
            srcEvent: t
          });
        }
      });
      var It = 2500,
          Ct = 25;

      function kt() {
        tt.apply(this, arguments);
        var t = E(this.handler, this);
        this.touch = new wt(this.manager, t), this.mouse = new ht(this.manager, t), this.primaryTouch = null, this.lastTouches = [];
      }

      function _t(t) {
        var e = t.changedPointers[0];

        if (e.identifier === this.primaryTouch) {
          var i = {
            x: e.clientX,
            y: e.clientY
          };
          this.lastTouches.push(i);
          var n = this.lastTouches;
          setTimeout(function () {
            var t = n.indexOf(i);
            t > -1 && n.splice(t, 1);
          }, It);
        }
      }

      T(kt, tt, {
        handler: function handler(t, e, i) {
          var n = "touch" == i.pointerType,
              o = "mouse" == i.pointerType;

          if (!(o && i.sourceCapabilities && i.sourceCapabilities.firesTouchEvents)) {
            if (n) (function (t, e) {
              t & D ? (this.primaryTouch = e.changedPointers[0].identifier, _t.call(this, e)) : t & (U | Y) && _t.call(this, e);
            }).call(this, e, i);else if (o && function (t) {
              for (var e = t.srcEvent.clientX, i = t.srcEvent.clientY, n = 0; n < this.lastTouches.length; n++) {
                var o = this.lastTouches[n],
                    s = Math.abs(e - o.x),
                    r = Math.abs(i - o.y);
                if (s <= Ct && r <= Ct) return !0;
              }

              return !1;
            }.call(this, i)) return;
            this.callback(t, e, i);
          }
        },
        destroy: function destroy() {
          this.touch.destroy(), this.mouse.destroy();
        }
      });

      var St = F(u.style, "touchAction"),
          Lt = St !== l,
          At = "auto",
          Mt = "manipulation",
          Pt = "none",
          Ft = "pan-x",
          zt = "pan-y",
          Bt = function () {
        if (!Lt) return !1;
        var t = {},
            e = o.CSS && o.CSS.supports;
        return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function (i) {
          t[i] = !e || o.CSS.supports("touch-action", i);
        }), t;
      }();

      function Nt(t, e) {
        this.manager = t, this.set(e);
      }

      Nt.prototype = {
        set: function set(t) {
          "compute" == t && (t = this.compute()), Lt && this.manager.element.style && Bt[t] && (this.manager.element.style[St] = t), this.actions = t.toLowerCase().trim();
        },
        update: function update() {
          this.set(this.manager.options.touchAction);
        },
        compute: function compute() {
          var t = [];
          return y(this.manager.recognizers, function (e) {
            w(e.options.enable, [e]) && (t = t.concat(e.getTouchAction()));
          }), function (t) {
            if (S(t, Pt)) return Pt;
            var e = S(t, Ft),
                i = S(t, zt);
            if (e && i) return Pt;
            if (e || i) return e ? Ft : zt;
            if (S(t, Mt)) return Mt;
            return At;
          }(t.join(" "));
        },
        preventDefaults: function preventDefaults(t) {
          var e = t.srcEvent,
              i = t.offsetDirection;
          if (this.manager.session.prevented) e.preventDefault();else {
            var n = this.actions,
                o = S(n, Pt) && !Bt[Pt],
                s = S(n, zt) && !Bt[zt],
                r = S(n, Ft) && !Bt[Ft];

            if (o) {
              var l = 1 === t.pointers.length,
                  a = t.distance < 2,
                  c = t.deltaTime < 250;
              if (l && a && c) return;
            }

            if (!r || !s) return o || s && i & V || r && i & $ ? this.preventSrc(e) : void 0;
          }
        },
        preventSrc: function preventSrc(t) {
          this.manager.session.prevented = !0, t.preventDefault();
        }
      };
      var Rt = 1,
          Ot = 2,
          qt = 4,
          Dt = 8,
          jt = Dt,
          Ut = 16;

      function Yt(t) {
        this.options = a({}, this.defaults, t || {}), this.id = z++, this.manager = null, this.options.enable = I(this.options.enable, !0), this.state = Rt, this.simultaneous = {}, this.requireFail = [];
      }

      function Xt(t) {
        return t & Ut ? "cancel" : t & Dt ? "end" : t & qt ? "move" : t & Ot ? "start" : "";
      }

      function Ht(t) {
        return t == J ? "down" : t == G ? "up" : t == H ? "left" : t == W ? "right" : "";
      }

      function Wt(t, e) {
        var i = e.manager;
        return i ? i.get(t) : t;
      }

      function Gt() {
        Yt.apply(this, arguments);
      }

      function Jt() {
        Gt.apply(this, arguments), this.pX = null, this.pY = null;
      }

      function Vt() {
        Gt.apply(this, arguments);
      }

      function $t() {
        Yt.apply(this, arguments), this._timer = null, this._input = null;
      }

      function Zt() {
        Gt.apply(this, arguments);
      }

      function Kt() {
        Gt.apply(this, arguments);
      }

      function Qt() {
        Yt.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0;
      }

      function te(t, e) {
        return (e = e || {}).recognizers = I(e.recognizers, te.defaults.preset), new ee(t, e);
      }

      Yt.prototype = {
        defaults: {},
        set: function set(t) {
          return a(this.options, t), this.manager && this.manager.touchAction.update(), this;
        },
        recognizeWith: function recognizeWith(t) {
          if (m(t, "recognizeWith", this)) return this;
          var e = this.simultaneous;
          return e[(t = Wt(t, this)).id] || (e[t.id] = t, t.recognizeWith(this)), this;
        },
        dropRecognizeWith: function dropRecognizeWith(t) {
          return m(t, "dropRecognizeWith", this) ? this : (t = Wt(t, this), delete this.simultaneous[t.id], this);
        },
        requireFailure: function requireFailure(t) {
          if (m(t, "requireFailure", this)) return this;
          var e = this.requireFail;
          return -1 === A(e, t = Wt(t, this)) && (e.push(t), t.requireFailure(this)), this;
        },
        dropRequireFailure: function dropRequireFailure(t) {
          if (m(t, "dropRequireFailure", this)) return this;
          t = Wt(t, this);
          var e = A(this.requireFail, t);
          return e > -1 && this.requireFail.splice(e, 1), this;
        },
        hasRequireFailures: function hasRequireFailures() {
          return this.requireFail.length > 0;
        },
        canRecognizeWith: function canRecognizeWith(t) {
          return !!this.simultaneous[t.id];
        },
        emit: function emit(t) {
          var e = this,
              i = this.state;

          function n(i) {
            e.manager.emit(i, t);
          }

          i < Dt && n(e.options.event + Xt(i)), n(e.options.event), t.additionalEvent && n(t.additionalEvent), i >= Dt && n(e.options.event + Xt(i));
        },
        tryEmit: function tryEmit(t) {
          if (this.canEmit()) return this.emit(t);
          this.state = 32;
        },
        canEmit: function canEmit() {
          for (var t = 0; t < this.requireFail.length;) {
            if (!(this.requireFail[t].state & (32 | Rt))) return !1;
            t++;
          }

          return !0;
        },
        recognize: function recognize(t) {
          var e = a({}, t);
          if (!w(this.options.enable, [this, e])) return this.reset(), void (this.state = 32);
          this.state & (jt | Ut | 32) && (this.state = Rt), this.state = this.process(e), this.state & (Ot | qt | Dt | Ut) && this.tryEmit(e);
        },
        process: function process(t) {},
        getTouchAction: function getTouchAction() {},
        reset: function reset() {}
      }, T(Gt, Yt, {
        defaults: {
          pointers: 1
        },
        attrTest: function attrTest(t) {
          var e = this.options.pointers;
          return 0 === e || t.pointers.length === e;
        },
        process: function process(t) {
          var e = this.state,
              i = t.eventType,
              n = e & (Ot | qt),
              o = this.attrTest(t);
          return n && (i & Y || !o) ? e | Ut : n || o ? i & U ? e | Dt : e & Ot ? e | qt : Ot : 32;
        }
      }), T(Jt, Gt, {
        defaults: {
          event: "pan",
          threshold: 10,
          pointers: 1,
          direction: Z
        },
        getTouchAction: function getTouchAction() {
          var t = this.options.direction,
              e = [];
          return t & V && e.push(zt), t & $ && e.push(Ft), e;
        },
        directionTest: function directionTest(t) {
          var e = this.options,
              i = !0,
              n = t.distance,
              o = t.direction,
              s = t.deltaX,
              r = t.deltaY;
          return o & e.direction || (e.direction & V ? (o = 0 === s ? X : s < 0 ? H : W, i = s != this.pX, n = Math.abs(t.deltaX)) : (o = 0 === r ? X : r < 0 ? G : J, i = r != this.pY, n = Math.abs(t.deltaY))), t.direction = o, i && n > e.threshold && o & e.direction;
        },
        attrTest: function attrTest(t) {
          return Gt.prototype.attrTest.call(this, t) && (this.state & Ot || !(this.state & Ot) && this.directionTest(t));
        },
        emit: function emit(t) {
          this.pX = t.deltaX, this.pY = t.deltaY;
          var e = Ht(t.direction);
          e && (t.additionalEvent = this.options.event + e), this._super.emit.call(this, t);
        }
      }), T(Vt, Gt, {
        defaults: {
          event: "pinch",
          threshold: 0,
          pointers: 2
        },
        getTouchAction: function getTouchAction() {
          return [Pt];
        },
        attrTest: function attrTest(t) {
          return this._super.attrTest.call(this, t) && (Math.abs(t.scale - 1) > this.options.threshold || this.state & Ot);
        },
        emit: function emit(t) {
          if (1 !== t.scale) {
            var e = t.scale < 1 ? "in" : "out";
            t.additionalEvent = this.options.event + e;
          }

          this._super.emit.call(this, t);
        }
      }), T($t, Yt, {
        defaults: {
          event: "press",
          pointers: 1,
          time: 251,
          threshold: 9
        },
        getTouchAction: function getTouchAction() {
          return [At];
        },
        process: function process(t) {
          var e = this.options,
              i = t.pointers.length === e.pointers,
              n = t.distance < e.threshold,
              o = t.deltaTime > e.time;
          if (this._input = t, !n || !i || t.eventType & (U | Y) && !o) this.reset();else if (t.eventType & D) this.reset(), this._timer = v(function () {
            this.state = jt, this.tryEmit();
          }, e.time, this);else if (t.eventType & U) return jt;
          return 32;
        },
        reset: function reset() {
          clearTimeout(this._timer);
        },
        emit: function emit(t) {
          this.state === jt && (t && t.eventType & U ? this.manager.emit(this.options.event + "up", t) : (this._input.timeStamp = f(), this.manager.emit(this.options.event, this._input)));
        }
      }), T(Zt, Gt, {
        defaults: {
          event: "rotate",
          threshold: 0,
          pointers: 2
        },
        getTouchAction: function getTouchAction() {
          return [Pt];
        },
        attrTest: function attrTest(t) {
          return this._super.attrTest.call(this, t) && (Math.abs(t.rotation) > this.options.threshold || this.state & Ot);
        }
      }), T(Kt, Gt, {
        defaults: {
          event: "swipe",
          threshold: 10,
          velocity: .3,
          direction: V | $,
          pointers: 1
        },
        getTouchAction: function getTouchAction() {
          return Jt.prototype.getTouchAction.call(this);
        },
        attrTest: function attrTest(t) {
          var e,
              i = this.options.direction;
          return i & (V | $) ? e = t.overallVelocity : i & V ? e = t.overallVelocityX : i & $ && (e = t.overallVelocityY), this._super.attrTest.call(this, t) && i & t.offsetDirection && t.distance > this.options.threshold && t.maxPointers == this.options.pointers && p(e) > this.options.velocity && t.eventType & U;
        },
        emit: function emit(t) {
          var e = Ht(t.offsetDirection);
          e && this.manager.emit(this.options.event + e, t), this.manager.emit(this.options.event, t);
        }
      }), T(Qt, Yt, {
        defaults: {
          event: "tap",
          pointers: 1,
          taps: 1,
          interval: 300,
          time: 250,
          threshold: 9,
          posThreshold: 10
        },
        getTouchAction: function getTouchAction() {
          return [Mt];
        },
        process: function process(t) {
          var e = this.options,
              i = t.pointers.length === e.pointers,
              n = t.distance < e.threshold,
              o = t.deltaTime < e.time;
          if (this.reset(), t.eventType & D && 0 === this.count) return this.failTimeout();

          if (n && o && i) {
            if (t.eventType != U) return this.failTimeout();
            var s = !this.pTime || t.timeStamp - this.pTime < e.interval,
                r = !this.pCenter || rt(this.pCenter, t.center) < e.posThreshold;
            if (this.pTime = t.timeStamp, this.pCenter = t.center, r && s ? this.count += 1 : this.count = 1, this._input = t, 0 === this.count % e.taps) return this.hasRequireFailures() ? (this._timer = v(function () {
              this.state = jt, this.tryEmit();
            }, e.interval, this), Ot) : jt;
          }

          return 32;
        },
        failTimeout: function failTimeout() {
          return this._timer = v(function () {
            this.state = 32;
          }, this.options.interval, this), 32;
        },
        reset: function reset() {
          clearTimeout(this._timer);
        },
        emit: function emit() {
          this.state == jt && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
        }
      }), te.VERSION = "2.0.7", te.defaults = {
        domEvents: !1,
        touchAction: "compute",
        enable: !0,
        inputTarget: null,
        inputClass: null,
        preset: [[Zt, {
          enable: !1
        }], [Vt, {
          enable: !1
        }, ["rotate"]], [Kt, {
          direction: V
        }], [Jt, {
          direction: V
        }, ["swipe"]], [Qt], [Qt, {
          event: "doubletap",
          taps: 2
        }, ["tap"]], [$t]],
        cssProps: {
          userSelect: "none",
          touchSelect: "none",
          touchCallout: "none",
          contentZooming: "none",
          userDrag: "none",
          tapHighlightColor: "rgba(0,0,0,0)"
        }
      };

      function ee(t, e) {
        var i;
        this.options = a({}, te.defaults, e || {}), this.options.inputTarget = this.options.inputTarget || t, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = t, this.input = new ((i = this).options.inputClass || (R ? mt : O ? wt : N ? kt : ht))(i, et), this.touchAction = new Nt(this, this.options.touchAction), ie(this, !0), y(this.options.recognizers, function (t) {
          var e = this.add(new t[0](t[1]));
          t[2] && e.recognizeWith(t[2]), t[3] && e.requireFailure(t[3]);
        }, this);
      }

      function ie(t, e) {
        var i,
            n = t.element;
        n.style && (y(t.options.cssProps, function (o, s) {
          i = F(n.style, s), e ? (t.oldCssProps[i] = n.style[i], n.style[i] = o) : n.style[i] = t.oldCssProps[i] || "";
        }), e || (t.oldCssProps = {}));
      }

      ee.prototype = {
        set: function set(t) {
          return a(this.options, t), t.touchAction && this.touchAction.update(), t.inputTarget && (this.input.destroy(), this.input.target = t.inputTarget, this.input.init()), this;
        },
        stop: function stop(t) {
          this.session.stopped = t ? 2 : 1;
        },
        recognize: function recognize(t) {
          var e = this.session;

          if (!e.stopped) {
            var i;
            this.touchAction.preventDefaults(t);
            var n = this.recognizers,
                o = e.curRecognizer;
            (!o || o && o.state & jt) && (o = e.curRecognizer = null);

            for (var s = 0; s < n.length;) {
              i = n[s], 2 === e.stopped || o && i != o && !i.canRecognizeWith(o) ? i.reset() : i.recognize(t), !o && i.state & (Ot | qt | Dt) && (o = e.curRecognizer = i), s++;
            }
          }
        },
        get: function get(t) {
          if (t instanceof Yt) return t;

          for (var e = this.recognizers, i = 0; i < e.length; i++) {
            if (e[i].options.event == t) return e[i];
          }

          return null;
        },
        add: function add(t) {
          if (m(t, "add", this)) return this;
          var e = this.get(t.options.event);
          return e && this.remove(e), this.recognizers.push(t), t.manager = this, this.touchAction.update(), t;
        },
        remove: function remove(t) {
          if (m(t, "remove", this)) return this;

          if (t = this.get(t)) {
            var e = this.recognizers,
                i = A(e, t);
            -1 !== i && (e.splice(i, 1), this.touchAction.update());
          }

          return this;
        },
        on: function on(t, e) {
          if (t !== l && e !== l) {
            var i = this.handlers;
            return y(L(t), function (t) {
              i[t] = i[t] || [], i[t].push(e);
            }), this;
          }
        },
        off: function off(t, e) {
          if (t !== l) {
            var i = this.handlers;
            return y(L(t), function (t) {
              e ? i[t] && i[t].splice(A(i[t], e), 1) : delete i[t];
            }), this;
          }
        },
        emit: function emit(t, e) {
          this.options.domEvents && function (t, e) {
            var i = s.createEvent("Event");
            i.initEvent(t, !0, !0), i.gesture = e, e.target.dispatchEvent(i);
          }(t, e);
          var i = this.handlers[t] && this.handlers[t].slice();

          if (i && i.length) {
            e.type = t, e.preventDefault = function () {
              e.srcEvent.preventDefault();
            };

            for (var n = 0; n < i.length;) {
              i[n](e), n++;
            }
          }
        },
        destroy: function destroy() {
          this.element && ie(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
        }
      }, a(te, {
        INPUT_START: D,
        INPUT_MOVE: j,
        INPUT_END: U,
        INPUT_CANCEL: Y,
        STATE_POSSIBLE: Rt,
        STATE_BEGAN: Ot,
        STATE_CHANGED: qt,
        STATE_ENDED: Dt,
        STATE_RECOGNIZED: jt,
        STATE_CANCELLED: Ut,
        STATE_FAILED: 32,
        DIRECTION_NONE: X,
        DIRECTION_LEFT: H,
        DIRECTION_RIGHT: W,
        DIRECTION_UP: G,
        DIRECTION_DOWN: J,
        DIRECTION_HORIZONTAL: V,
        DIRECTION_VERTICAL: $,
        DIRECTION_ALL: Z,
        Manager: ee,
        Input: tt,
        TouchAction: Nt,
        TouchInput: wt,
        MouseInput: ht,
        PointerEventInput: mt,
        TouchMouseInput: kt,
        SingleTouchInput: xt,
        Recognizer: Yt,
        AttrRecognizer: Gt,
        Tap: Qt,
        Pan: Jt,
        Swipe: Kt,
        Pinch: Vt,
        Rotate: Zt,
        Press: $t,
        on: C,
        off: k,
        each: y,
        merge: x,
        extend: b,
        assign: a,
        inherit: T,
        bindFn: E,
        prefixed: F
      }), (void 0 !== o ? o : "undefined" != typeof self ? self : {}).Hammer = te, (n = function () {
        return te;
      }.call(e, i, e, t)) === l || (t.exports = n);
    }(window, document);
  }, function (t, e, i) {
    "use strict";

    i.r(e);
    i(0), i(4);

    function n(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    var o = function () {
      function t(e) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.body = document.querySelector("body"), this.galleryId = e, this.galleryLink = document.querySelectorAll("#" + this.galleryId + " a"), this.galleryImage = document.querySelectorAll("#" + this.galleryId + " img"), this.litebox = null, this.liteboxImage = null, this.liteboxId = "litebox-" + this.galleryId, this.imageURL = null, this.isFullscreen = !1, this.fullscreenBtnJustClicked = !1, this.openState = !1, this.index = null, this.mouseTime = null, this.imageCloseTransitionTime = 400;
      }

      var e, i, o;
      return e = t, (i = [{
        key: "init",
        value: function value() {
          var t = this;
          this.render();

          for (var e = function e(_e) {
            t.galleryLink[_e].addEventListener("click", function (i) {
              i.preventDefault(), t.openState = !0, t.litebox.style.visibility = "visible", t.litebox.style.opacity = "1", t.showImage(_e), t.showCaption(_e), t.liteboxImage.addEventListener("click", function (t) {
                t.stopPropagation(), console.log("liteboxImage propagation stopped");
              }), t.liteboxCaption.addEventListener("click", function (t) {
                t.stopPropagation(), console.log("caption propagation stopped");
              });
            });
          }, i = 0; i < this.galleryLink.length; i++) {
            e(i);
          }

          this.events();
        }
      }, {
        key: "closeLitebox",
        value: function value() {
          var t = this;
          this.openState && (console.log("closed litebox"), this.openState = !1, this.liteboxLoader.style.visibility = "hidden", this.litebox.style.visibility = "hidden", this.litebox.style.opacity = 0, this.litebox.style.pointerEvents = "none", this.liteboxPrevBtn.style.cursor = "pointer", this.liteboxNextBtn.style.cursor = "pointer", this.liteboxPrevBtn.style.borderColor = "#FFF", this.liteboxNextBtn.style.borderColor = "#FFF", setTimeout(function () {
            t.liteboxImage.style.visibility = "hidden";
          }, this.imageCloseTransitionTime), this.liteboxImage.style.transform = "translate(-50%, -50%)  scale(1.2)", this.body.classList.remove("noscroll"), this.index = void 0);
        }
      }, {
        key: "showPrev",
        value: function value() {
          var t = this;
          this.openState && (this.index > 0 ? (console.log("show prev"), this.liteboxImage.style.opacity = 0, this.liteboxImage.style.visibility = "visible", this.liteboxCaption.style.opacity = 0, setTimeout(function () {
            t.showImage(t.index - 1), t.showCaption(t.index);
          }, this.imageCloseTransitionTime)) : console.log("No more images."));
        }
      }, {
        key: "showNext",
        value: function value() {
          var t = this;
          this.openState && (this.index < this.galleryLink.length - 1 ? (console.log("show next"), this.liteboxImage.style.opacity = 0, this.liteboxImage.style.visibility = "visible", this.liteboxCaption.style.opacity = 0, setTimeout(function () {
            t.showImage(t.index + 1), t.showCaption(t.index);
          }, this.imageCloseTransitionTime)) : console.log("No more images."));
        }
      }, {
        key: "toggleFullscreen",
        value: function value() {
          !this.isFullscreen && this.openState ? (this.isFullscreen = !0, this.liteboxFullscreenBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="22" height="22" viewBox="0 0 192 192" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,192v-192h192v192z" fill="none"></path><g fill="#ffffff"><path d="M63.9,25.5125c-3.5297,0.05517 -6.34834,2.9577 -6.3,6.4875v25.6h-25.6c-2.30807,-0.03264 -4.45492,1.18 -5.61848,3.17359c-1.16356,1.99358 -1.16356,4.45924 0,6.45283c1.16356,1.99358 3.31041,3.20623 5.61848,3.17359h32c3.53448,-0.00035 6.39965,-2.86552 6.4,-6.4v-32c0.02369,-1.72992 -0.65393,-3.39575 -1.87846,-4.61793c-1.22453,-1.22218 -2.89166,-1.89659 -4.62154,-1.86957zM127.9,25.5125c-3.5297,0.05517 -6.34834,2.9577 -6.3,6.4875v32c0.00035,3.53448 2.86552,6.39965 6.4,6.4h32c2.30807,0.03264 4.45492,-1.18 5.61848,-3.17359c1.16356,-1.99358 1.16356,-4.45924 0,-6.45283c-1.16356,-1.99358 -3.31041,-3.20623 -5.61848,-3.17359h-25.6v-25.6c0.02369,-1.72992 -0.65393,-3.39575 -1.87846,-4.61793c-1.22453,-1.22218 -2.89166,-1.89659 -4.62154,-1.86957zM32,121.6c-2.30807,-0.03264 -4.45492,1.18 -5.61848,3.17359c-1.16356,1.99358 -1.16356,4.45924 0,6.45283c1.16356,1.99358 3.31041,3.20623 5.61848,3.17359h25.6v25.6c-0.03264,2.30807 1.18,4.45492 3.17359,5.61848c1.99358,1.16356 4.45924,1.16356 6.45283,0c1.99358,-1.16356 3.20623,-3.31041 3.17359,-5.61848v-32c-0.00035,-3.53448 -2.86552,-6.39965 -6.4,-6.4zM128,121.6c-3.53448,0.00035 -6.39965,2.86552 -6.4,6.4v32c-0.03264,2.30807 1.18,4.45492 3.17359,5.61848c1.99358,1.16356 4.45924,1.16356 6.45283,0c1.99358,-1.16356 3.20623,-3.31041 3.17359,-5.61848v-25.6h25.6c2.30807,0.03264 4.45492,-1.18 5.61848,-3.17359c1.16356,-1.99358 1.16356,-4.45924 0,-6.45283c-1.16356,-1.99358 -3.31041,-3.20623 -5.61848,-3.17359z"></path></g></g></svg>', document.documentElement.requestFullScreen ? document.documentElement.requestFullScreen() : document.documentElement.mozRequestFullScreen ? document.documentElement.mozRequestFullScreen() : document.documentElement.webkitRequestFullScreen ? document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT) : document.documentElement.msRequestFullscreen && document.documentElement.msRequestFullscreen()) : this.isFullscreen && this.openState && (this.isFullscreen = !1, this.liteboxFullscreenBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="22" height="22" viewBox="0 0 192 192" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,192v-192h192v192z" fill="none"></path><g fill="#ffffff"><path d="M38.4,25.6c-6.9956,0 -12.8,5.8044 -12.8,12.8v25.6c-0.03264,2.30807 1.18,4.45492 3.17359,5.61848c1.99358,1.16356 4.45924,1.16356 6.45283,0c1.99358,-1.16356 3.20623,-3.31041 3.17359,-5.61848v-25.6h25.6c2.30807,0.03264 4.45492,-1.18 5.61848,-3.17359c1.16356,-1.99358 1.16356,-4.45924 0,-6.45283c-1.16356,-1.99358 -3.31041,-3.20623 -5.61848,-3.17359zM128,25.6c-2.30807,-0.03264 -4.45492,1.18 -5.61848,3.17359c-1.16356,1.99358 -1.16356,4.45924 0,6.45283c1.16356,1.99358 3.31041,3.20623 5.61848,3.17359h25.6v25.6c-0.03264,2.30807 1.18,4.45492 3.17359,5.61848c1.99358,1.16356 4.45924,1.16356 6.45283,0c1.99358,-1.16356 3.20623,-3.31041 3.17359,-5.61848v-25.6c0,-6.9956 -5.8044,-12.8 -12.8,-12.8zM31.9,121.5125c-3.5297,0.05517 -6.34834,2.9577 -6.3,6.4875v25.6c0,6.9956 5.8044,12.8 12.8,12.8h25.6c2.30807,0.03264 4.45492,-1.18 5.61848,-3.17359c1.16356,-1.99358 1.16356,-4.45924 0,-6.45283c-1.16356,-1.99358 -3.31041,-3.20623 -5.61848,-3.17359h-25.6v-25.6c0.02369,-1.72992 -0.65393,-3.39575 -1.87846,-4.61793c-1.22453,-1.22218 -2.89166,-1.89659 -4.62154,-1.86957zM159.9,121.5125c-3.5297,0.05517 -6.34834,2.9577 -6.3,6.4875v25.6h-25.6c-2.30807,-0.03264 -4.45492,1.18 -5.61848,3.17359c-1.16356,1.99358 -1.16356,4.45924 0,6.45283c1.16356,1.99358 3.31041,3.20623 5.61848,3.17359h25.6c6.9956,0 12.8,-5.8044 12.8,-12.8v-25.6c0.02369,-1.72992 -0.65393,-3.39575 -1.87846,-4.61793c-1.22453,-1.22218 -2.89166,-1.89659 -4.62154,-1.86957z"></path></g></g></svg>', document.cancelFullScreen ? document.cancelFullScreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitCancelFullScreen ? document.webkitCancelFullScreen() : document.msExitFullscreen && document.msExitFullscreen());
        }
      }, {
        key: "events",
        value: function value() {
          var t = this;
          document.addEventListener("keyup", function (e) {
            27 === e.keyCode && t.closeLitebox();
          }), this.liteboxCloseBtn.addEventListener("click", function () {
            return t.closeLitebox();
          }), this.liteboxPrevBtn.addEventListener("click", function (e) {
            e.stopPropagation(), t.showPrev();
          }), this.liteboxNextBtn.addEventListener("click", function (e) {
            e.stopPropagation(), t.showNext();
          }), document.addEventListener("keyup", function (e) {
            37 === e.keyCode && t.showPrev();
          }), document.addEventListener("keyup", function (e) {
            39 === e.keyCode && t.showNext();
          });
          var e = new Hammer(this.litebox);
          e.get("swipe").set({
            direction: Hammer.DIRECTION_ALL
          }), e.on("swiperight", function () {
            return t.showPrev();
          }), e.on("swipeleft", function () {
            return t.showNext();
          }), e.on("swipeup swipedown", function () {
            return t.closeLitebox();
          }), this.liteboxFullscreenBtn.addEventListener("click", function () {
            t.fullscreenBtnJustClicked = !0, t.toggleFullscreen();
          }), document.addEventListener("keyup", function (e) {
            70 === e.keyCode && (t.fullscreenBtnJustClicked = !0, t.toggleFullscreen());
          }), document.addEventListener("fullscreenchange", function () {
            t.fullscreenBtnJustClicked ? t.fullscreenBtnJustClicked = !1 : t.toggleFullscreen();
          }, !1), document.addEventListener("webkitfullscreenchange", function () {
            t.fullscreenBtnJustClicked ? t.fullscreenBtnJustClicked = !1 : t.toggleFullscreen();
          }, !1), document.addEventListener("mozfullscreenchange", function () {
            t.fullscreenBtnJustClicked ? t.fullscreenBtnJustClicked = !1 : t.toggleFullscreen();
          }, !1);
        }
      }, {
        key: "showCaption",
        value: function value(t) {
          try {
            var e = this.galleryImage[t].dataset.caption;
          } catch (t) {
            console.log("Closed before the next caption could be computed.");
          }

          e ? (this.liteboxCaption.innerText = e, this.liteboxCaption.style.visibility = "visible", this.liteboxCaption.style.opacity = 1) : (this.liteboxCaption.style.visibility = "hidden", this.liteboxCaption.style.opacity = 0);
        }
      }, {
        key: "showImage",
        value: function value(t) {
          var e = this;
          this.index = t;

          try {
            this.imageURL = this.galleryLink[this.index].getAttribute("href"), this.liteboxContainer.innerHTML = '<img src="'.concat(this.imageURL, '" class="litebox__image ').concat(this.liteboxId, '">'), this.liteboxImage = document.querySelector(".litebox__image.".concat(this.liteboxId)), this.litebox.style.pointerEvents = "auto", this.loader(), this.showImageIndex(), this.body.classList.add("noscroll"), this.disabledArrow(), this.openState && (document.addEventListener("mousemove", function (t) {
              return e.autohideNav(t);
            }), document.addEventListener("keydown", function (t) {
              return e.autohideNav(t);
            }), document.addEventListener("touchstart", function (t) {
              return e.autohideNav(t);
            }));
          } catch (t) {
            console.log("Closed before the next image could be computed.");
          }
        }
      }, {
        key: "autohideNav",
        value: function value(t) {
          var e = this;
          document.querySelector("#".concat(this.liteboxId, " .litebox__caption")).style.opacity = 1, document.querySelector("#".concat(this.liteboxId, " .litebox__prev-btn")).style.opacity = 1, document.querySelector("#".concat(this.liteboxId, " .litebox__next-btn")).style.opacity = 1, document.querySelector("#".concat(this.liteboxId, " .litebox__close-btn")).style.opacity = 1, document.querySelector("#".concat(this.liteboxId, " .litebox__fullscreen-btn")).style.opacity = 1, document.querySelector("#".concat(this.liteboxId, " .litebox__image-index")).style.opacity = 1, document.querySelector("#".concat(this.liteboxId, " .litebox__gradient-bg")).style.opacity = 1, clearTimeout(this.mouseTimer), this.mouseTimer = setTimeout(function () {
            document.querySelector("#".concat(e.liteboxId, " .litebox__caption")).style.opacity = 0, document.querySelector("#".concat(e.liteboxId, " .litebox__prev-btn")).style.opacity = 0, document.querySelector("#".concat(e.liteboxId, " .litebox__next-btn")).style.opacity = 0, document.querySelector("#".concat(e.liteboxId, " .litebox__close-btn")).style.opacity = 0, document.querySelector("#".concat(e.liteboxId, " .litebox__fullscreen-btn")).style.opacity = 0, document.querySelector("#".concat(e.liteboxId, " .litebox__image-index")).style.opacity = 0, document.querySelector("#".concat(e.liteboxId, " .litebox__gradient-bg")).style.opacity = 0;
          }, 3e3);
        }
      }, {
        key: "disabledArrow",
        value: function value(t) {
          0 === this.index ? (this.liteboxPrevBtn.style.borderColor = "#888", this.liteboxPrevBtn.style.cursor = "not-allowed") : this.index === this.galleryLink.length - 1 ? (this.liteboxNextBtn.style.borderColor = "#888", this.liteboxNextBtn.style.cursor = "not-allowed") : (this.liteboxPrevBtn.style.borderColor = "white", this.liteboxPrevBtn.style.cursor = "pointer", this.liteboxNextBtn.style.borderColor = "white", this.liteboxNextBtn.style.cursor = "pointer");
        }
      }, {
        key: "showImageIndex",
        value: function value() {
          this.liteboxImageIndex.innerText = this.index + 1 + " / " + this.galleryLink.length;
        }
      }, {
        key: "loader",
        value: function value() {
          var t = this;
          this.liteboxLoader.style.visibility = "visible", this.liteboxLoader.style.opacity = 1, this.liteboxImage.addEventListener("load", function () {
            t.openState ? (t.liteboxLoader.style.visibility = "hidden", t.liteboxLoader.style.opacity = 0, setTimeout(function () {
              t.liteboxImage.style.visibility = "visible", t.liteboxImage.style.opacity = "1", t.liteboxImage.style.transform = "translate(-50%, -50%)  scale(1)";
            }, 200)) : t.closeLitebox();
          });
        }
      }, {
        key: "render",
        value: function value() {
          this.litebox = this.body.appendChild(document.createElement("div")), this.litebox.classList.add("litebox", this.liteboxId), this.litebox.id = this.liteboxId, this.liteboxContainer = this.litebox.appendChild(document.createElement("div")), this.liteboxContainer.classList.add("litebox__container", this.liteboxId), this.liteboxGradientBG = this.litebox.appendChild(document.createElement("div")), this.liteboxGradientBG.classList.add("litebox__gradient-bg", this.liteboxId), this.liteboxCloseBtn = this.litebox.appendChild(document.createElement("div")), this.liteboxCloseBtn.classList.add("litebox__close-btn", this.liteboxId), this.liteboxCloseBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 192 192" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,192v-192h192v192z" fill="none"></path><g fill="#ffffff"><path d="M51.0625,38.275c-5.20634,0.00645 -9.89015,3.1654 -11.8469,7.99004c-1.95675,4.82464 -0.7966,10.35375 2.9344,13.98496l35.75,35.75l-35.75,35.75c-3.34383,3.21046 -4.6908,7.97781 -3.52143,12.46344c1.16937,4.48563 4.67237,7.98862 9.15799,9.15799c4.48563,1.16937 9.25297,-0.1776 12.46343,-3.52143l35.75,-35.75l35.75,35.75c3.21045,3.34388 7.97782,4.69089 12.46348,3.52152c4.48566,-1.16937 7.98867,-4.67238 9.15804,-9.15804c1.16937,-4.48566 -0.17764,-9.25302 -3.52152,-12.46348l-35.75,-35.75l35.75,-35.75c3.78573,-3.67989 4.92402,-9.30644 2.86636,-14.16848c-2.05765,-4.86204 -6.88913,-7.96214 -12.16636,-7.80652c-3.32542,0.09909 -6.48164,1.4889 -8.8,3.875l-35.75,35.75l-35.75,-35.75c-2.41289,-2.48033 -5.72714,-3.87818 -9.1875,-3.875z"></path></g></g></svg>', this.liteboxFullscreenBtn = this.litebox.appendChild(document.createElement("div")), this.liteboxFullscreenBtn.classList.add("litebox__fullscreen-btn", this.liteboxId), this.liteboxFullscreenBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="22" height="22" viewBox="0 0 192 192" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,192v-192h192v192z" fill="none"></path><g fill="#ffffff"><path d="M38.4,25.6c-6.9956,0 -12.8,5.8044 -12.8,12.8v25.6c-0.03264,2.30807 1.18,4.45492 3.17359,5.61848c1.99358,1.16356 4.45924,1.16356 6.45283,0c1.99358,-1.16356 3.20623,-3.31041 3.17359,-5.61848v-25.6h25.6c2.30807,0.03264 4.45492,-1.18 5.61848,-3.17359c1.16356,-1.99358 1.16356,-4.45924 0,-6.45283c-1.16356,-1.99358 -3.31041,-3.20623 -5.61848,-3.17359zM128,25.6c-2.30807,-0.03264 -4.45492,1.18 -5.61848,3.17359c-1.16356,1.99358 -1.16356,4.45924 0,6.45283c1.16356,1.99358 3.31041,3.20623 5.61848,3.17359h25.6v25.6c-0.03264,2.30807 1.18,4.45492 3.17359,5.61848c1.99358,1.16356 4.45924,1.16356 6.45283,0c1.99358,-1.16356 3.20623,-3.31041 3.17359,-5.61848v-25.6c0,-6.9956 -5.8044,-12.8 -12.8,-12.8zM31.9,121.5125c-3.5297,0.05517 -6.34834,2.9577 -6.3,6.4875v25.6c0,6.9956 5.8044,12.8 12.8,12.8h25.6c2.30807,0.03264 4.45492,-1.18 5.61848,-3.17359c1.16356,-1.99358 1.16356,-4.45924 0,-6.45283c-1.16356,-1.99358 -3.31041,-3.20623 -5.61848,-3.17359h-25.6v-25.6c0.02369,-1.72992 -0.65393,-3.39575 -1.87846,-4.61793c-1.22453,-1.22218 -2.89166,-1.89659 -4.62154,-1.86957zM159.9,121.5125c-3.5297,0.05517 -6.34834,2.9577 -6.3,6.4875v25.6h-25.6c-2.30807,-0.03264 -4.45492,1.18 -5.61848,3.17359c-1.16356,1.99358 -1.16356,4.45924 0,6.45283c1.16356,1.99358 3.31041,3.20623 5.61848,3.17359h25.6c6.9956,0 12.8,-5.8044 12.8,-12.8v-25.6c0.02369,-1.72992 -0.65393,-3.39575 -1.87846,-4.61793c-1.22453,-1.22218 -2.89166,-1.89659 -4.62154,-1.86957z"></path></g></g></svg>', this.liteboxLoader = this.litebox.appendChild(document.createElement("div")), this.liteboxLoader.classList.add("litebox__loader", this.liteboxId), this.liteboxPrevBtn = this.litebox.appendChild(document.createElement("div")), this.liteboxPrevBtn.classList.add("litebox__prev-btn", this.liteboxId), this.liteboxNextBtn = this.litebox.appendChild(document.createElement("div")), this.liteboxNextBtn.classList.add("litebox__next-btn", this.liteboxId), this.liteboxCaption = this.litebox.appendChild(document.createElement("div")), this.liteboxCaption.classList.add("litebox__caption", this.liteboxId), this.liteboxImageIndex = this.litebox.appendChild(document.createElement("div")), this.liteboxImageIndex.classList.add("litebox__image-index", this.liteboxId);
        }
      }]) && n(e.prototype, i), o && n(e, o), t;
    }();

    e.default = o;
  }]).default;
});